import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaBars, FaSearch, FaBell, FaUser, FaSignOutAlt, 
  FaCog, FaHeart, FaChevronDown, FaTimes, FaHome,
  FaFire, FaComment, FaCamera, FaVideo, FaUserPlus
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import './header.css';

const Header = ({ toggleSidebar, isMobile, user }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  
  const dropdownRef = useRef(null);
  const searchRef = useRef(null);
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearch(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getAvatarUrl = () => {
    if (user?.avatar) {
      return `${process.env.REACT_APP_UPLOADS_URL}/${user.avatar}`;
    }
    return 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e';
  };

  const handleSearch = (e) => {
    if (e.key === 'Enter' && searchValue.trim()) {
      navigate(`/discover?search=${encodeURIComponent(searchValue.trim())}`);
      setShowSearch(false);
      setSearchValue('');
    }
  };

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Partie gauche */}
        <div className="header-left">
          {isMobile && (
            <button className="header-menu-btn" onClick={toggleSidebar}>
              <FaBars />
            </button>
          )}
          
          <div className="header-logo" onClick={() => navigate('/dashboard')}>
            <span className="logo-dot"></span>
            <span className="logo-text">MURIMA</span>
          </div>

         
        </div>

        {/* Barre de recherche desktop */}
        {!isMobile && (
          <div className="header-search">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Rechercher un profil..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyPress={handleSearch}
            />
          </div>
        )}

        {/* Partie droite */}
        <div className="header-right">
          {isMobile && (
            <button 
              className="header-icon-btn"
              onClick={() => setShowSearch(!showSearch)}
            >
              <FaSearch />
            </button>
          )}

          <button className="header-icon-btn">
            <FaBell />
            <span className="notification-dot"></span>
          </button>

          {/* Profil utilisateur */}
          <div className="header-profile" ref={dropdownRef}>
            <button 
              className="profile-btn"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <div className="profile-avatar"  style={{width: '40px',
  height: '40px'}}>
                <img src={getAvatarUrl()} alt={user?.pseudo} />
                <span className="avatar-status"></span>
              </div>
              <span className="profile-name">{user?.pseudo || 'Compte'}</span>
              <FaChevronDown className={`profile-arrow ${showDropdown ? 'rotated' : ''}`} />
            </button>

            {/* Dropdown menu */}
            {showDropdown && (
              <div className="profile-dropdown">
                <div className="dropdown-user">
                  <img src={getAvatarUrl()} alt={user?.pseudo} />
                  <div className="user-details">
                    <strong>{user?.pseudo || 'Utilisateur'}</strong>
                    <span>{user?.email || 'email@example.com'}</span>
                  </div>
                </div>

                <div className="dropdown-menu">
                  <button onClick={() => { navigate('/my-profile'); setShowDropdown(false); }}>
                    <FaUser /> Mon profil
                  </button>
                  <button onClick={() => { navigate('/favorites'); setShowDropdown(false); }}>
                    <FaHeart /> Favoris
                  </button>
                 
                  <div className="dropdown-divider"></div>
                  <button onClick={handleLogout} className="logout-btn">
                    <FaSignOutAlt /> Déconnexion
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Barre de recherche mobile */}
      {showSearch && isMobile && (
        <div className="mobile-search" ref={searchRef}>
          <FaSearch className="mobile-search-icon" />
          <input
            type="text"
            placeholder="Rechercher..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyPress={handleSearch}
            autoFocus
          />
          <button 
            className="mobile-search-close"
            onClick={() => setShowSearch(false)}
          >
            <FaTimes />
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;